import { render, staticRenderFns } from "./MemberInvitationDeleteModal.vue?vue&type=template&id=f2da0fe0&"
import script from "./MemberInvitationDeleteModal.vue?vue&type=script&lang=js&"
export * from "./MemberInvitationDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports